var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showDate
      ? _c(
          "p",
          {
            staticClass: "font-bold leading-none",
            staticStyle: { "font-size": "13px", color: "#A5B4C0" },
          },
          [_vm._v(_vm._s(_vm.formattedDate(_vm.meetingNoteList[0]?.startDate)))]
        )
      : _c(
          "p",
          {
            staticClass: "font-bold leading-none",
            staticStyle: { "font-size": "13px", color: "#4A5A69" },
          },
          [_vm._v(_vm._s(_vm.$t("extendMenu.meetingNote.listTitle")))]
        ),
    _c(
      "div",
      { staticClass: "mt-2 space-y-2" },
      _vm._l(_vm.meetingNoteList, function (meetingNoteItem) {
        return _c("RoomMeetingNoteItem", {
          key: meetingNoteItem.key,
          attrs: { "show-buttons": _vm.showDate, note: meetingNoteItem },
          on: { click: (note) => _vm.$emit("click", note) },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }